import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa6';
import styles from './BackToTop.module.css';

function BackToTop() {
    const [isVisible, setIsVisible] = useState(false);
    const toggleVisibility = () => {
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const distanceFromBottom = scrollHeight - (scrollY + windowHeight);

    if (distanceFromBottom < 400) {
        setIsVisible(true);
    } else {
        setIsVisible(false);
    }
};

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <button
            type="button"
            onClick={scrollToTop}
            className={`${styles.backToTopBtn} ${isVisible ? styles.show : ''}`}
            aria-label="Voltar ao topo"
        >
            <FaArrowUp />
        </button>
    );
}

export default BackToTop;